var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"line-height":"0","display":"inline-flex"}},[(_vm.url)?_c('el-image',{style:({
        width: _vm.width + 'px',
        borderRadius: _vm.radius + 'px',
        height: _vm.height + 'px',
        display: 'block'
    }),attrs:{"src":_vm.$util.img(_vm.url ? _vm.url : '/upload/front/none-image.jpg'),"preview-src-list":[_vm.$util.img(_vm.url)],"fit":"cover"}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('img',{style:({
                width: _vm.width + 'px',
                borderRadius: _vm.radius + 'px',
                height: _vm.height + 'px',
                display: 'block'
            }),attrs:{"src":_vm.$util.img('/upload/front/none-image.jpg')}})])]):_c('div',{staticClass:"like-image",style:({
        width: _vm.width + 'px',
        height: _vm.height + 'px'
    }),attrs:{"flex":"cross:center main:center"}},[_vm._v("\n        未上传\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7b8172c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CImage.vue
// module id = null
// module chunks = 